import _ from 'lodash';
import { getAxiosClient } from '../../api';

export const fetchProjectFormats = async (project, forceFetch = false) => {
  const httpClient = await getAxiosClient();

  const hasCache = _.has(
    window.editorLoader,
    `formats.${project.objectId}.formats.items`
  );

  if (!forceFetch && hasCache) {
    return window.editorLoader.formats[project.objectId];
  }

  // I don't need to fetch the default formats because they are displayed in the modal and
  // the user has to choose which one want to use. We only display formats that the user
  // has chosen to use.

  /**
   * Get custom formats
   */
  const params = {
    include: 'editor_project_formats_default_pointer',
  };

  if (project.isGlobal) {
    params.filterEqual_editor_project_types_default_pointer = project.objectId;
  } else {
    params.filterEqual_editor_project_types_pointer = project.objectId;
  }

  const promiseCustomFormats = httpClient.get(
    `${process.env.PARSE_API_URL}/editor_project_formats`,
    { params }
  );

  try {
    const responses = await Promise.all([promiseCustomFormats]);
    let items = [];

    responses.forEach((response) => {
      const respItems = response.data.data.reduce((acc, item) => {
        acc.push(item);

        return acc;
      }, []);

      items = [...items, ...respItems];
    });

    items.sort((i1, i2) => {
      if (i1.isGlobal) {
        return -1;
      } else if (!i1.isGlobal && i2.isGlobal) {
        return 1;
      } else {
        return 0;
      }
    });

    return {
      formats: {
        allowNew: true,
        items,
      },
    };
  } catch (errors) {
    // TODO: handle errors correctly
    console.error(errors);
    return errors;
  }
};
